/**
 * Service for common logic of contract components.
 *
 */
import {Injectable} from '@angular/core';
import {
  ContractVersionCriteriaDto,
  ContractVersionDto,
  ContractVersionService,
  SearchDataProvider,
} from '../../../bonding_shared';

@Injectable()
export class ClientContractGuiService {
  /**
   * Keeps selected criteria for contract search view
   */
  searchDataProvider: SearchDataProvider<ContractVersionCriteriaDto, ContractVersionDto>;

  constructor(private contractVersionService: ContractVersionService) {
    this.searchDataProvider = new SearchDataProvider<ContractVersionCriteriaDto, ContractVersionDto>(
      contractVersionService
    );
    this.searchDataProvider.searchCriteria.criteria = this.contractVersionService.getClientContractsCriteria(true);
    this.searchDataProvider.additionalQueryParams = [{key: 'single', val: 'true'}];
  }
}
